import { RoomModel } from 'src/common/stores/models/room-model';
import { SearchCriteriaModel } from 'src/common/stores/models/search-criteria-model';

import { DateUtils } from 'utils/date-utils';

import { CreateLodgingConversation, LodgingConversationMetadataInput } from 'src/common/__generated__/api';

export const getCreateConversationInput = (
  message: string,
  searchCriteria: SearchCriteriaModel,
  createdAt: string,
  propertyId: string,
  name: string,
  emailAddress: string
): CreateLodgingConversation.Variables => ({
  message,
  metadata: getCreateConversationMetadata(searchCriteria, createdAt, propertyId, name, emailAddress)
});

const getCreateConversationMetadata = (
  searchCriteria: SearchCriteriaModel,
  createdAt: string,
  propertyId: string,
  name: string,
  emailAddress: string
): LodgingConversationMetadataInput => {
  const rooms = searchCriteria && searchCriteria.rooms;
  const startDate = searchCriteria && searchCriteria.startDate;
  const endDate = searchCriteria && searchCriteria.endDate;

  return {
    checkIn: startDate && DateUtils.parseDateString(startDate),
    checkOut: endDate && DateUtils.parseDateString(endDate),
    rooms: rooms && rooms.map(mapRooms),
    createdAt,
    propertyId,
    from: {
      name,
      emailAddress
    }
  };
};

const mapChildren = (room: RoomModel) => (room.children && room.children.map(child => child.age)) || [];

const mapRooms = (room: RoomModel) => ({
  numberOfAdults: room.adults || 0,
  childAges: mapChildren(room)
});
